import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmAiGovernanceNativeAiCapabilitiesRoute: InvariantJiraRoute = {
	name: 'products-jsm-rovo-ai-usage',
	path: '/jira/settings/products/jira-service-management-rovo-ai/usage',
	exact: true,
};
